if (!customElements.get('modular-look-gallery')) {
  customElements.define(
    'modular-look-gallery',
    class extends HTMLElement {
      constructor() {
        super();
        this.points = this.querySelectorAll('.point-button');
        this.points.forEach(point => point.addEventListener('click', () => this.handlePointClick(point)));
      }

      connectedCallback() {
        this.initSwiper();
      }

      initSwiper() {
        this.swiper = new Swiper(this, {
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          effect: window.matchMedia('(min-width: 769px)').matches ? 'fade' : '',
          fadeEffect: { crossFade: true },
          speed: 1000,
          breakpoints: {
            0 : {
              slidesPerView: 'auto',
              spaceBetween: 16,
              loop: true
            },
            769: {
              slidesPerView: 1,
              spaceBetween: 0,
              loop: true
            }
          }
        });
      }
    
      handlePointClick(point) {
        if(point.classList.contains('active')) return;
        const mainSlide = point.closest('.swiper-slide-wrapper');
        mainSlide.querySelectorAll('.point-button').forEach(p => p.classList.remove('active'));
        mainSlide.querySelectorAll('.show-product-option input').forEach(p => p.checked = false);

        point.classList.add('active');
        
        const bundle = mainSlide.querySelector(`.bundle-content-point-${point.dataset.index}[data-id="${point.dataset.id}"]`);
      
        mainSlide.querySelectorAll('.bundle-points-content').forEach((content) => {
          if (content === bundle) {
              content.classList.remove('hidden');
              content.classList.add('active');
                if(window.matchMedia('(max-width: 768px)').matches) {
                  content.style.position = 'absolute';
                }
                content.style.opacity = 0; // Start with opacity 0
                var animation = content.animate(
                  [{ opacity: 0 }, { opacity: 1 }],
                  { duration: 500, easing: 'ease-in-out', fill: 'forwards' }
                );
                animation.onfinish = () => {
                  content.style.opacity = ''
                  content.style.position = '';
                };
              // }
          } else {
              content.classList.remove('active');
              content.style.opacity = 1;
              if(window.matchMedia('(max-width: 768px)').matches) {
                content.style.position = 'absolute';
              }
              var animation = content.animate(
                  [{ opacity: 1 }, { opacity: 0 }],
                  { duration: 500, easing: 'ease-in-out', fill: 'forwards' }
              );
              animation.onfinish = () => {
                  content.classList.add('hidden');

                  content.style.opacity = ''
                  content.style.position = '';
                  
              };
            // } else {
            //   content.classList.add('hidden');

            // }

          }
      });

      }
    }
  );
}